export { default } from "bullitttime-embermodelsgochips/models/device";
